const filterPageMedici = () => {
	const BASE_URL = document.getElementById('base_url').value;
	const strutturaID = document.getElementById('medici-vue').dataset.strutturaid;
	let endpoint_medici = '';
	if(strutturaID){
		endpoint_medici = `${BASE_URL}/wp-json/api/v1/medici?q=`+strutturaID;
	} else{
		endpoint_medici = `${BASE_URL}/wp-json/api/v1/medici`;
	}
	if ( document.getElementById('medici-vue') ) {
		var app = new Vue({
			el: '#medici-vue',
			data() {
				return {
					medici : [],
					selectedRole : '',
					selectedName : '',
					selectedOrderName: '',
					selectedSpecia : '',
					selectedSpeciaExact: '',
					selectedStruttura : '',
					page: 1,
					perPage: 12,
					pages: [],	
					totaleMedici : '',
					loading: true,
				}
			},
			mounted(){
				fetch( endpoint_medici )
				.then(res => res.json())
				.then(data => {
					this.medici = data.map( item => {
						const { nome, specia, ruolo, responsabile, photo, url, strutture } = item;
						return {
							nome,
							ruolo,
							responsabile,
							specia,
							photo,
							url,
							strutture
						}
					})
					this.sortBy('AZ');
					this.loading = false;
				})
			},
			methods: {
				toggleDrop(e){
					let selettoriFiltriSearchInput = document.querySelectorAll(".filters-item.--search .filter-search__input input");				
					let isVisible = e.target.closest(".filters-item").classList.contains('visible-list');

					selettoriFiltriSearchInput.forEach(el => {
						el.closest(".filters-item").classList.remove('visible-list');
					});	

					e.target.closest(".filters-item").classList.toggle('visible-list',!isVisible);			
					
					if(!isVisible){
						this.selectedSpeciaExact = '';
					}
					window.addEventListener('mouseup', function(e){   
						selettoriFiltriSearchInput.forEach(el => {
							if (!el.contains(e.target) && el.closest(".filters-item").classList.contains('visible-list')){
								el.closest(".filters-item").classList.remove('visible-list');
							}
						});
						
					});
				},
				selectCurrentFilterUI(selectedFilter, selectedValue){
					if(selectedFilter == 'role'){
						this.selectedRole = selectedValue;
					} else if (selectedFilter == 'name'){
						this.selectedName = selectedValue;
					}
					else if (selectedFilter == 'specia'){
						this.selectedSpecia = selectedValue;
						this.selectedSpeciaExact = selectedValue;
					}
					else if (selectedFilter == 'struttura'){
						this.selectedStruttura = selectedValue;
					}
				},
				paginate (posts) {
					let page = this.page;
					let perPage = this.perPage;
					let from = (page * perPage) - perPage;
					let to = (page * perPage);
					return  posts.slice(from, to);
				},
				setPages() {
					let numberOfPages = Math.ceil(this.totaleMedici / this.perPage);
					this.pages = []; /* svuoto e ri-riempio */
					for (let index = 1; index <= numberOfPages; index++) {
						this.pages.push(index);
					}
				},
				sortMedici(element, key){
					if(key == 'AZ'){
						this.selectedOrderName = 'Nome A-Z';
						element.sort(function(a, b) {
							var textA = a.nome.toLowerCase();
							var textB = b.nome.toLowerCase();
							return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
						});
					} else {
						this.selectedOrderName = 'Nome Z-A';
						element.sort(function(a, b) {
							var textA = a.nome.toLowerCase();
							var textB = b.nome.toLowerCase();
							return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
						});
					}
				},
				sortBy(key) {
					let mediciResponsabili, mediciBase;
					mediciResponsabili = this.medici.filter( item => item.responsabile == true);
					mediciBase = this.medici.filter( item => item.responsabile != true); //sia null che false
					this.sortMedici(mediciResponsabili, key);
					this.sortMedici(mediciBase, key);
					return this.medici = mediciResponsabili.concat(mediciBase);
				},
				resetFilters(){
					this.selectedRole = '';
					this.selectedName = '';
					this.selectedSpecia = '';
					this.selectedSpeciaExact = '';
				},
				highlightResult(current, filter) {
					var str = current;
					var regex = new RegExp(filter, 'i');
					var indexQuery = (str.toLowerCase()).indexOf(filter.toLowerCase());
					var highlightText = str.substring(indexQuery, indexQuery + filter.length);
					return str.replace(regex, '<span class="fw-bold">' + highlightText + '</span>')
				},
				htmlDecode(input) {
					var doc = new DOMParser().parseFromString(input, "text/html");
					return doc.documentElement.textContent;
				},
				standardizeApostrophe(input) {
					return input.replace(/'/g, "’");
				}
			},
			computed: {
				mediciRole(){
					let role = [];
					this.computedMedici.forEach(medico => {
						if(medico.ruolo != null){
							medico.ruolo.forEach(el => {
								if(!role.includes(el) ){
									role.push(el);
								}
							});
						}
					});
					role.sort();
					var roleFiltered = role.filter(
						(item) => {	
							let role = this.selectedRole ? item.toLowerCase().includes(this.selectedRole.toLowerCase()) : true
							return role
						}
					)
					return roleFiltered;
				},
				mediciSpecia(){
					let speciali = [];
					this.computedMedici.forEach(medico => {
						if(medico.specia != null){
							medico.specia.forEach(el => {
								if(!speciali.includes(el.name) && el != null){
									speciali.push(el.name);
								}
							});
						};
						
					});
					speciali.sort();
					var specialiFiltered = speciali.filter(
						(item) => {	
							let specia = this.selectedSpecia ? item.toLowerCase().includes(this.selectedSpecia.toLowerCase()) : true
							return specia
						}
					)
					return specialiFiltered;
				},
				mediciNames(){
					let name = [];
					this.computedMedici.forEach(medico => {
						if(!name.includes(medico.nome) && medico.nome != ""){
							name.push({
								nome: medico.nome,
								url : medico.url
							});
						}
					});
					name.sort(function(a, b) {
						var textA = a.nome.toLowerCase();
						var textB = b.nome.toLowerCase();
						return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
					});
					return name;
				
				},
				mediciStrutture(){
					let strutture = [];
					/* riempio l'elenco delle strutture in base ai medici filtrati */
					this.computedMedici.forEach(medico => {
						if(medico.strutture != null){
							medico.strutture.forEach(el => {
								if(!strutture.includes(el.name) && el.name != null){
									strutture.push(el.name);
								}
							});
						}
					});
					strutture.sort();
					/* lascio visibili solo le strutture corrispondenti ai caratteri che sto scrivendo in selectedStruttura */
					var strFiltered = strutture.filter(
						(item) => {	
							let struttura = this.selectedStruttura ?  item.toLowerCase().includes( this.selectedStruttura.toLowerCase() ) : true;
							return struttura
						}
					)
					return strFiltered;
					
				},
				paginatedMedici(){
					this.totaleMedici = this.computedMedici.length;
					return this.paginate(this.computedMedici);
				},
				computedMedici() {
					return this.medici.filter((item) => {
						var decodedName = this.htmlDecode(item.nome).toLowerCase();
						var standardizedInputName = this.standardizeApostrophe(this.selectedName.toLowerCase());
					
						var role = this.selectedRole ? (item.ruolo != null && item.ruolo.find(r => r.toLowerCase().includes(this.selectedRole.toLowerCase()))) : true;
						var name = standardizedInputName ? (decodedName.includes(standardizedInputName)) : true;

						var specia;
						if (this.selectedSpeciaExact) {
							// Filtro per selectedSpeciaExact per un confronto esatto
							specia = item.specia != null && item.specia.some(r => r.name === this.selectedSpeciaExact);
						} else if (this.selectedSpecia) {
							// Filtro per selectedSpecia per un confronto che include la stringa
							specia = item.specia != null && item.specia.some(r => r.name.toLowerCase().includes(this.selectedSpecia.toLowerCase()));
						} else {
							// Se nessun filtro di specialità è impostato
							specia = true;
						}

						var struttura = this.selectedStruttura ? (item.strutture != null && item.strutture.find(r => r.name != null && r.name.toLowerCase().includes(this.selectedStruttura.toLowerCase()))) : true;
						return role && name && specia && struttura;
					});
				  }
						  
			},
			watch: { 
				totaleMedici() {
					this.setPages(); /* ogni volta che totaleMedici cambia esegi setPages */
				}
			},
			filters: {
				trimWords(value){
					return value.split(" ").splice(0,20).join(" ") + '...';
				}
			}
		})
	}
}

export default filterPageMedici;